export const XP_LEVEL_COLORS_DEFAULT = [
    '#FF9E00',
    '#7dc009',
    '#0192FC',
    '#D20DF2',
    '#F84E4E',
    '#00DB76',
    '#F326FF',
    '#01C817',
    '#00A26A',
    '#ff7805',
    '#7D5FDB',
]

export const XP_LEVEL_COLORS_LIGHT = [
    '#FFF3CC',
    '#F1FBCB',
    '#CCF4FE',
    '#FECEF5',
    '#FEE7DB',
    '#CAFDD1',
    '#FFDCF5',
    '#D6FCCA',
    '#C8FAD5',
    '#FFEECD',
    '#EFE6FF',
]

export const XP_LEVEL_COLORS_DARK = [
    '#B76300',
    '#4F8A04',
    '#0071D8',
    '#A409D0',
    '#B2273F',
    '#009D74',
    '#9728B7',
    '#00902A',
    '#008B68',
    '#B74202',
    '#5A42B7',
]

/**
 * It's should be the same with utils in server
 */
export const LEVEL_THRESHOLDS = [
    0, 50, 125, 275, 500, 800, 1175, 1625, 2150, 2750, 3425, 4175, 5000, 5900,
    6875, 7925, 9050, 10250, 11525, 12875, 14200, 15700, 17275, 18925, 20650,
    22450, 24325, 26275, 28300, 30400, 32575, 34825, 37150, 39550, 42025, 44575,
    47200, 49900, 52675, 55525, 58450, 61450, 64525,
]

export const DAILY_XP_TARGET = 60
